"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidOperationError = void 0;
class InvalidOperationError extends Error {
    constructor(msg) {
        super(msg ? `InvalidOperationError: ${msg}` : "InvalidOperationError");
    }
}
exports.InvalidOperationError = InvalidOperationError;
//# sourceMappingURL=InvalidOperationError.js.map